import i from './interval-manager';

export default i;
